import React from 'react'
import { Link } from 'react-router'
import cx from 'classnames'

import s from './Link.scss'


const _Link = ({ children, className, activeClassName, to, toOLD, toTAB, title, target, style, download, onClick }) => {
  if (toOLD || toTAB) {
    return (
      <a
        className={cx(s.link, className)}
        href={toOLD || toTAB}
        target={target || (toTAB ? '_blank' : null)}
        download={download}
        style={style}
        onClick={onClick}
      >
        {
          Boolean(title)
            ? title
            : children
        }
      </a>
    )
  }

  return (
    <Link
      className={cx(s.link, className)}
      {...{ activeClassName, to, title, style, onClick }}
    >
      {
        Boolean(title)
          ? title
          : children
      }
    </Link>
  )
}


export default _Link
